import * as actionTypes from "./action-types";

export const setGenericFormState = (genericFormState) => {
    return {
        type: actionTypes.SET_GENERIC_FORM_STATE,
        ...genericFormState
    }
}